import { ParentPlanService } from 'us-web-services';

// Angular source: apps/angular/src/js/ng/common/services/paywall-service/paywall-service.js#checkForPaywall
//
// Gates an action (e.g. sending a message) behind membership.
// Rule: a member can always take the action; a non-member can take it only if
// the sitter is "my sitter" — either a direct connection or previously booked.
// If neither, trigger `openPaywall` to surface the paywall modal; otherwise
// run the action.

interface PaywallableSitter {
  relationship?: unknown;
}

const isMySitter = (sitter: PaywallableSitter): boolean => {
  const rel = sitter.relationship as
    | {
        booked?: boolean;
        bookingCount?: number;
        connections?: { direct?: Array<unknown> | unknown };
      }
    | undefined;
  if (!rel) return false;
  if (rel.booked || (rel.bookingCount ?? 0) > 0) return true;
  const direct = rel.connections?.direct;
  if (Array.isArray(direct)) return direct.length > 0;
  return !!direct;
};

export const checkForPaywall = async ({
  userId,
  sitter,
  action,
  openPaywall,
}: {
  userId?: number;
  sitter: PaywallableSitter;
  action: () => void;
  openPaywall: () => void;
}): Promise<void> => {
  if (!userId) {
    action();
    return;
  }
  if (isMySitter(sitter)) {
    action();
    return;
  }
  try {
    const resp = await ParentPlanService.getByFilter({
      params: { active: true, parentId: userId, userId },
    });
    const hasActivePlan = (resp.data?.data ?? []).length > 0;
    if (hasActivePlan) {
      action();
    } else {
      openPaywall();
    }
  } catch {
    action();
  }
};
